import React from 'react';
import PropTypes from 'prop-types';

import StarIcon from '../../../assets/star-four-pointed.svg';
import Button from './Button';
import styles from '../../styles/views/components/GenerateButton.module.scss';

const GenerateButton = ({ onClick, isEmpty, isTranscriptsNotUploaded }) => (
  <Button
    value={t(isEmpty ? 'button.generate' : 'button.regenerate', { ns: i18next.Namespace.COMMON })}
    variant="secondary"
    color="gold"
    onClick={onClick}
    iconAsComponent={<StarIcon />}
    extraClass={[styles.btn, isTranscriptsNotUploaded && styles.disabled].join(' ')}
    isDisabled={isTranscriptsNotUploaded}
    tooltip={isTranscriptsNotUploaded ? t('components.uploadTranscriptsFirst', { ns: i18next.Namespace.COMMON }) : ''}
  />
);

GenerateButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool,
  isTranscriptsNotUploaded: PropTypes.bool,
};

GenerateButton.defaultProps = {
  isEmpty: true,
  isTranscriptsNotUploaded: false,
};

export default GenerateButton;
